import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const notificationItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  deeplink: z.string(),
  read: z.boolean(),
  createdAt: z.string(),
});

export const unreadCountResponseSchema = z.object({
  count: z.number().int(),
});

export class NotificationItemDto extends createZodDto(notificationItemSchema) {}

export class UnreadCountResponseDto extends createZodDto(unreadCountResponseSchema) {}
